import translate from "../../../common/Dictionary";
import BootstrapModal from '../../../common/BootstrapModal';
import PrivacyPolicyNL from '../PrivacyPolicyNL';
import PrivacyPolicyFR from '../PrivacyPolicyFR';

const PrivacyStatementModal = ({ shown, userData, onClose }) => {
    return (
        <BootstrapModal
            shown={shown}
            size="modal-xl"
            onClose={onClose}
            title={translate("privactPolicyHeader", userData.language)}
            body={
                <div className="row axa-warning-modal-padding">
                    {userData.language === "NL" ? (<PrivacyPolicyNL />) : <PrivacyPolicyFR />}
                </div>
            }
            footer={
                <div className="row" align="center">
                    <div className="col">
                        <button className="btn btn-danger" onClick={onClose}>{translate("btnCloseModal", userData.language)}</button>
                    </div>
                </div>
            }
        />
    );
};

export default PrivacyStatementModal;
